/**
 * Created by pawel on 2017-02-07.
 * @version  0.1.210621 Dodanie obłsugi $('body').data('loaderOnceDescription', 'Example once description').addClass('loading')
 */
(function ($) {

    var v = '0.1.220129';

    pw.doc('Loader', v, [
        '$().addClass("loading")',
        '<div data-loader-description="Loading..." data-loader-target="body"></div>',
        'segment:reload[data-segment]'
    ]);
    console.info('Loader: v:' + v);


    $.each(['show', 'hide'], function (i, ev) {
        var el = $.fn[ev];
        $.fn[ev] = function () {
            this.trigger(ev);
            return el.apply(this, arguments);
        };
    });


    // Add Events by jQuery methods methods
    // "addClass", "toggleClass", "removeClass"
    $.map(["addClass", "removeClass"], function (method) {
        // Store the original handler
        var originalMethod = $.fn[method];

        $.fn[method] = function () {
            // Execute the original hanlder.
            var result = null;
            if (this[0]) {

                var oldClass = this[0].className;
                result = originalMethod.apply(this, arguments);
                var newClass = this[0].className;

                // trigger a custom event
                if ($.inArray('loading', arguments) >= 0) {
                    this.trigger('loader:' + method, [this, arguments]);
                }

            } else {
                result = originalMethod.apply(this, arguments);
            }
            return result;
        };
    });

    window.pwLoadreTemplate =
        '<div class="pw-lo-con">' +
        '<div class="h-fix"></div>' +
        '<div class="lo">' +
        ' <div class="lo-img"></div>' +
        ' <div class="lo-msg"></div>' +
        '</div>' +
        '</div>';


    window.pwLoadreImage = $('#basePath').val() + '/img/loader-ring-alt.svg';
    var $loader = $(window.pwLoadreTemplate);

    $.get(window.pwLoadreImage, function (data) {
        if(data) {
            $loader.find('.lo-img').html(data);
            $('.lo-img').html(data);
        } else {
            console.error('No data')
        }
        // var $svg = jQuery(data);
        // $svg = $svg.removeAttr('xmlns:a');
        // $svgCode = $('<div>').append($svg).html();
        // console.log($svgCode);

        console.log('--------------- GET Create loader complete');
    }, 'text');


    if(!localStorage['loader-image']) {
        console.log('--------------- Create loader complete');
    } else {
        console.log('Use session ------------------------ ');
    }


    $(document)
        .ready(function () {

        })
        // Call to addClass events
        .on("loader:addClass", function (e, ui, params) {

            var ux = (ui.data('loaderTarget') && $(ui.data('loaderTarget')).length) ? $(ui.data('loaderTarget')) : ui,
                description = ui.data('loaderDescription')//  $e.attr('data-loader-description'),
                myLoader = null
            ;

            if(ui.data('loaderOnceDescription')) {
                description = ui.data('loaderOnceDescription');
                ui.data('loaderOnceDescription', null);
            }

            if (ux.children('div.lo-con').length === 0) {
                // console.log('pw.loader add');
                myLoader = $loader.clone();
                ux.append(myLoader);
                if (description) {
                    $('<p class="lo-description">' + description + '</p>').appendTo(ux.find('.lo-msg').eq(0));
                    // console.info('add loader description: ' + description);
                }
                // myLoader.css({height: $e.innerHeight()})
            } else {
                // console.log('pw.loader exists');
            }

        })
        // Call to removeClass events
        .on('loader:removeClass', function (e, ui, params) {
            var ux = (ui.data('loaderTarget') && $(ui.data('loaderTarget')).length) ? $(ui.data('loaderTarget')) : ui;
            ux.find('> div.pw-lo-con').css({opacity: 0}).delay(1000).remove();
        });

})(jQuery);